<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import Page from '~/enums/page'

const model = defineModel<boolean>()

function close (): void {
  model.value = false
}

async function onGoToFillingOutButtonClick (): Promise<void> {
  await navigateTo(Page.SupplierProducts)

  close()
}
</script>

<template>
  <CustomModalWindow v-model="model" :click-to-close="false" disable-close-icon>
    <template #title>
      Спасибо!
    </template>

    <p>Ваша заявка принята. Чтобы мы&nbsp;рассмотрели&nbsp;её, заполните информацию о&nbsp;товарах.</p>

    <template #action>
      <BasicButton color="green" :title="'Перейти к\xA0заполнению'" @click="onGoToFillingOutButtonClick" />
    </template>
  </CustomModalWindow>
</template>
